import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Edit3, Sparkles, Layers } from 'lucide-react';
const benefits = [{
  icon: <Clock className="w-6 h-6 md:w-8 md:h-8" data-id="element-12" />,
  title: 'Ahorro de Tiempo',
  description: 'No pierdas horas armando lecturas desde cero. Tenés todo listo para completar y entregar a tus consultantes.'
}, {
  icon: <Edit3 className="w-6 h-6 md:w-8 md:h-8" data-id="element-13" />,
  title: '100% Editable',
  description: 'Archivos editables para que puedas adaptarlos a tu estilo personal y a cada consultante.'
}, {
  icon: <Sparkles className="w-6 h-6 md:w-8 md:h-8" data-id="element-14" />,
  title: 'Diseño Profesional',
  description: 'Informes con apariencia premium que transmiten confianza y elevan tu imagen como facilitadora.'
}, {
  icon: <Layers className="w-6 h-6 md:w-8 md:h-8" data-id="element-15" />,
  title: 'Versatilidad Total',
  description: 'Ideal para cualquier tipo de lectura: sesión individual, paquetes, acompañamiento y seguimiento.'
}];
export function BenefitsSection() {
  return <section className="py-10 md:py-20 px-4 bg-mystic-800 relative" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-18">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 md:gap-6 p-4 md:p-6 rounded-2xl bg-mystic-900/50 border border-mystic-700 hover:border-gold/30 transition-colors" data-id="element-19">
              <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-mystic-700 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(212,168,83,0.15)]" data-id="element-20">
                {benefit.icon}
              </div>
              <div data-id="element-21">
                <h3 className="text-lg md:text-xl font-serif font-bold text-white mb-1 md:mb-2" data-id="element-22">
                  {benefit.title}
                </h3>
                <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-23">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}